/**
 * ESCHER FALLS — ブラウザで遊べる体験版。
 *
 * ## なぜ作るか
 * 流入は全件 App Store 内の検索で、外から辿り着く道が無かった。
 * この作品は**ブラウザでそのまま動く**（開発中ずっとそうだった）ので、
 * 最初の数面をそのまま置けば、リンク一つで即遊べる。
 * 「ダウンロードしてね」より、**押した瞬間に遊べる**方が桁違いに強い。
 *
 * ## 何を制限するか
 * 本編の最初の5面だけ。エクストラは閉じる。売り場・広告・評価・共有は
 * もともとブラウザでは口が出ない（各モジュールの規則1）ので、何も足さなくてよい。
 *
 * ## ビルドの分け方
 * `VITE_WEB_DEMO=1 vite build` で体験版になる。アプリのビルドでは未定義なので、
 * **アプリに体験版の制限が紛れ込むことはない**（フラグが無ければ全部 false）。
 */

export const IS_WEB_DEMO: boolean = import.meta.env.VITE_WEB_DEMO === '1';

/** 体験版で遊べる本編の面数。 */
export const DEMO_MAIN_LEVELS = 5;

/** 続きはここで。地域を付けない URL なら、開いた人のストアへ飛ぶ。 */
export const APP_STORE_URL = 'https://apps.apple.com/app/id6802934416';
